export default __webpack_public_path__ + "static/media/migrapreneur-logo-copy.9ce6cd1b.png";